import { render } from "./Headline.vue?vue&type=template&id=2c7ce8b7&scoped=true"
import script from "./Headline.vue?vue&type=script&lang=ts"
export * from "./Headline.vue?vue&type=script&lang=ts"

import "./Headline.vue?vue&type=style&index=0&id=2c7ce8b7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2c7ce8b7"

export default script